// React
import React, { memo } from 'react'
import PropTypes from 'prop-types'

// Components
import BLocationPicker from 'ui/blocks/Picker/Location'
import { LocationPickerOption } from 'ui/components/Picker/LocationPicker/Option'
import { LocationPickerSingleValue } from 'ui/components/Picker/LocationPicker/SingleValue'

// Shared
import { Field } from 'shared/form'

export const LocationSelect = memo(({
  name,
  options,
  locations,
  onChange,
  'data-tid': target,
  disabled,
  title,
  icon,
  deliveryDistances,
  showDeliveryDistances,
  label,
  showAddress
}) => (
  <BLocationPicker>
    <Field
      name={name}
      type="select"
      onChange={onChange}
      options={options}
      data-tid={target}
      disabled={disabled}
      components={{ Option: LocationPickerOption, SingleValue: LocationPickerSingleValue }}
      renderNativeOnMobile={false}
      locations={locations}
      title={title}
      icon={icon}
      deliveryDistances={deliveryDistances}
      showDeliveryDistances={showDeliveryDistances}
      showAddress={showAddress}
      hideLabel={!label}
      label={label}
      usePortal
      hideErrorLabel
      initialError
      openMenuOnFocus
    />
  </BLocationPicker>
))

LocationSelect.displayName = 'LocationSelect'

LocationSelect.propTypes = {
  'name': PropTypes.string.isRequired,
  'options': PropTypes.array.isRequired,
  'locations': PropTypes.object.isRequired,
  'onChange': PropTypes.func.isRequired,
  'data-tid': PropTypes.string,
  'disabled': PropTypes.bool,
  'title': PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  'icon': PropTypes.string,
  'deliveryDistances': PropTypes.array,
  'showDeliveryDistances': PropTypes.bool,
  'showAddress': PropTypes.bool,
  'label': PropTypes.string
}
